import Vue from 'vue'
import Router from 'vue-router'
import Shipping from '@/components/Shipping'
import ForgetPassword from '@/components/ForgetPassword'
// import ShopStart from '@/components/ShopStart'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Shipping',
      component: Shipping
    },
    {
      path: '/forget_password',
      name: 'ForgetPassword',
      component: ForgetPassword
    }
  ]
})
